import { CompanyLegal } from '@/components/company/CompanyLegal';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import Script from 'next/script';
import { Header, withLayout } from '../../components';

const Page: NextPage = () => {
  return withLayout(
    <>
      <NextSeo title="特定商取引法に基づく表記" noindex nofollow />
      <Script
        src="https://kenga.tech/pop-ups-ipvsrdmdinjcmrsi.js"
        strategy="beforeInteractive"
        type="text/javascript"
      />
      <Header />
      <CompanyLegal />
    </>,
  );
};

export default Page;
